import { Auth } from 'aws-amplify'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import { DefinedPermissions } from '../Constants/Permissions'

const GetCollectionPermissions = async () => {
  const permissionInput = {
    mobileNumber: Auth.user.attributes.phone_number,
  }
  const userPermissions = await GetUserPermissions(permissionInput)
  const permissions = []
  const permissionsArr = []
  if (userPermissions && userPermissions.userRolesAndPermissions) {
    userPermissions.userRolesAndPermissions.map(item => {
      permissions.push(...item.permissions)
      return item
    })
    permissions.map(permission => {
      permissionsArr.push(permission.name)
      return permission
    })
  }

  const EDitApproveOption = permissionsArr.includes(DefinedPermissions.DisplayApproveMovieOption)
  // console.log(EDitApproveOption, 'EDitApproveOption')
  // setApproveOptionBoolean(EDitApproveOption)
  return EDitApproveOption
}

export default GetCollectionPermissions
